// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * NOTE: the copious use of \`important\` is needed to overwrite
 * the default tooltip styling, and is required by the 3rd party
 * library being used, \`react-tooltip\`
 */

/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.coming-soon_coming-soon_tt9Ea {
    background-color: var(--data-primary) !important;
    border: 1px solid var(--ui-black-transparent) !important;
    border-radius: calc(0.5rem / 2) !important;
    box-shadow: 0 0 .5rem var(--ui-black-transparent) !important;
    padding: .75rem 1rem !important;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 1rem !important;
    line-height: 1.25rem !important;
    z-index: 47 !important;
}

.coming-soon_coming-soon_tt9Ea:after {
    content: "";
    border-top: 1px solid var(--ui-black-transparent) !important;
    border-left: 0 !important;
    border-bottom: 0 !important;
    border-right: 1px solid var(--ui-black-transparent) !important;
    border-radius: calc(0.5rem / 2);
    background-color: var(--data-primary) !important;
    height: 1rem !important;
    width: 1rem !important;
}

.coming-soon_show_sVGRX,
.coming-soon_show_sVGRX:before,
.coming-soon_show_sVGRX:after {
    opacity: 1 !important;
}

.coming-soon_left_t3Kyn:after {
    margin-top: -.5rem !important;
    right: -.5rem !important;
    transform: rotate(45deg) !important;
}

.coming-soon_right_nM46w:after {
    margin-top: -.5rem !important;
    left: -.5rem !important;
    transform: rotate(-135deg) !important;
}

.coming-soon_top_tnTlL:after {
    margin-right: -.5rem !important;
    bottom: -.5rem !important;
    transform: rotate(135deg) !important;
}

.coming-soon_bottom_TiWP1:after {
    margin-left: -.5rem !important;
    top: -.5rem !important;
    transform: rotate(-45deg) !important;
}

.coming-soon_coming-soon-image_OOfGs {
    width: 1.25rem;
    height: 1.25rem;
    vertical-align: middle;
}

[dir="ltr"] .coming-soon_coming-soon-image_OOfGs {
    margin-left: .125rem;
}

[dir="rtl"] .coming-soon_coming-soon-image_OOfGs {
    margin-right: .125rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/coming-soon/coming-soon.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,gDAAgD;IAChD,wDAAwD;IACxD,0CAA0C;IAC1C,4DAA4D;IAC5D,+BAA+B;IAC/B,sEAAsE;IACtE,0BAA0B;IAC1B,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,4DAA4D;IAC5D,yBAAyB;IACzB,2BAA2B;IAC3B,8DAA8D;IAC9D,+BAA+B;IAC/B,gDAAgD;IAChD,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/*\n * NOTE: the copious use of `important` is needed to overwrite\n * the default tooltip styling, and is required by the 3rd party\n * library being used, `react-tooltip`\n */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.coming-soon {\n    background-color: var(--data-primary) !important;\n    border: 1px solid var(--ui-black-transparent) !important;\n    border-radius: calc(0.5rem / 2) !important;\n    box-shadow: 0 0 .5rem var(--ui-black-transparent) !important;\n    padding: .75rem 1rem !important;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n    font-size: 1rem !important;\n    line-height: 1.25rem !important;\n    z-index: 47 !important;\n}\n\n.coming-soon:after {\n    content: \"\";\n    border-top: 1px solid var(--ui-black-transparent) !important;\n    border-left: 0 !important;\n    border-bottom: 0 !important;\n    border-right: 1px solid var(--ui-black-transparent) !important;\n    border-radius: calc(0.5rem / 2);\n    background-color: var(--data-primary) !important;\n    height: 1rem !important;\n    width: 1rem !important;\n}\n\n.show,\n.show:before,\n.show:after {\n    opacity: 1 !important;\n}\n\n.left:after {\n    margin-top: -.5rem !important;\n    right: -.5rem !important;\n    transform: rotate(45deg) !important;\n}\n\n.right:after {\n    margin-top: -.5rem !important;\n    left: -.5rem !important;\n    transform: rotate(-135deg) !important;\n}\n\n.top:after {\n    margin-right: -.5rem !important;\n    bottom: -.5rem !important;\n    transform: rotate(135deg) !important;\n}\n\n.bottom:after {\n    margin-left: -.5rem !important;\n    top: -.5rem !important;\n    transform: rotate(-45deg) !important;\n}\n\n.coming-soon-image {\n    width: 1.25rem;\n    height: 1.25rem;\n    vertical-align: middle;\n}\n\n[dir=\"ltr\"] .coming-soon-image {\n    margin-left: .125rem;\n}\n\n[dir=\"rtl\"] .coming-soon-image {\n    margin-right: .125rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coming-soon": `coming-soon_coming-soon_tt9Ea`,
	"comingSoon": `coming-soon_coming-soon_tt9Ea`,
	"show": `coming-soon_show_sVGRX`,
	"left": `coming-soon_left_t3Kyn`,
	"right": `coming-soon_right_nM46w`,
	"top": `coming-soon_top_tnTlL`,
	"bottom": `coming-soon_bottom_TiWP1`,
	"coming-soon-image": `coming-soon_coming-soon-image_OOfGs`,
	"comingSoonImage": `coming-soon_coming-soon-image_OOfGs`
};
export default ___CSS_LOADER_EXPORT___;
